import React from "react";
import classNames from "classnames";

import AscLink from "../../AscLink/AscLink";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscReflectionCompetitionsCard.module.scss";
import AscCompetitionWonItem from "../../AscCompetitionWonItem/AscCompetitionWonItem";

export interface AscReflectionCompetitionsCardProps {
  title: string;
  rankItems: {
    id: string;
    rank: number;
    createdAt: string;
    challenge: {
      title: string;
      thumbnail: {
        location: string;
      };
    };
  }[];
  className?: string;
  seeAllText?: string;
  seeAllLinkUrl?: string;
  loading?: boolean;
}

export default function AscReflectionCompetitionsCard({
  title,
  rankItems,
  className,
  loading = false,
  seeAllText = "See all",
  seeAllLinkUrl = "#",
}: AscReflectionCompetitionsCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      bodyClassName={styles.body}
      contentClassName={styles.content}
      title={
        <div className={styles.header}>
          <h5 className={classNames(styles.headerTitle)}>{title}</h5>
          <AscLink
            className={styles.headerLink}
            showIcon
            href={seeAllLinkUrl}
            innerWrapperTag="button"
          >
            {seeAllText}
          </AscLink>
        </div>
      }
      coverImageUrl={null}
      loading={loading}
    >
      {rankItems.length > 0 ? (
        rankItems.map(
          (rankItem, index) =>
            index < 3 && (
              <React.Fragment key={rankItem.id}>
                <AscCompetitionWonItem
                  imageUrl={rankItem.challenge.thumbnail?.location}
                  competitionName={rankItem.challenge.title}
                  rank={rankItem.rank}
                  date={rankItem.createdAt}
                />
                {index < 2 && <div className={styles.divider} />}
              </React.Fragment>
            )
        )
      ) : (
        <div className={styles.empty}>
          <span className={styles.emptyTitle}>
            Oh you haven’t won a reflection competition yet. Try it out today
          </span>
        </div>
      )}
    </AscGenericCard>
  );
}
